/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessAccount } from '../models/BusinessAccount';
import type { PhoneNumberDto } from '../models/PhoneNumberDto';
import type { RevokeWhatsAppAuthorizationTokenResponse } from '../models/RevokeWhatsAppAuthorizationTokenResponse';
import type { SendWhatsAppTextMessageRequest } from '../models/SendWhatsAppTextMessageRequest';
import type { WhatsAppCSRFTokenRequest } from '../models/WhatsAppCSRFTokenRequest';
import type { WhatsAppOAuthRequest } from '../models/WhatsAppOAuthRequest';
import type { WhatsAppTemplateMessageInfoDto } from '../models/WhatsAppTemplateMessageInfoDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WhatsAppService {

    /**
     * @param organizationId
     * @returns PhoneNumberDto OK
     * @throws ApiError
     */
    public static getWhatsAppPhoneNumbers(
        organizationId: string,
    ): CancelablePromise<Array<PhoneNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/organizations/{organizationId}/whatsapp/phoneNumbers',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param organizationId
     * @param businessId
     * @returns WhatsAppTemplateMessageInfoDto OK
     * @throws ApiError
     */
    public static getWhatsAppTemplates(
        organizationId: string,
        businessId?: string,
    ): CancelablePromise<Array<WhatsAppTemplateMessageInfoDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/organizations/{organizationId}/whatsapp/templates',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'businessId': businessId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Revokes the WhatsApp authorization token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns RevokeWhatsAppAuthorizationTokenResponse OK
     * @throws ApiError
     */
    public static revokeWhatsAppAuthorizationToken(
        organizationId: string,
    ): CancelablePromise<RevokeWhatsAppAuthorizationTokenResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/whatsapp/revokeAuthToken',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param organizationId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static sendWhatsAppTextMessage(
        organizationId: string,
        requestBody?: SendWhatsAppTextMessageRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/organizations/{organizationId}/whatsapp/sendTextMessage',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static storeWhatsAppCsrfToken(
        requestBody?: WhatsAppCSRFTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/storeWhatsAppCSRFToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param businessId
     * @param organizationId
     * @returns any OK
     * @throws ApiError
     */
    public static whatsAppStorePhoneNumbers(
        businessId: string,
        organizationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/organizations/{organizationId}/businessAccounts/{businessId}/phoneNumbers',
            path: {
                'businessId': businessId,
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param organizationId
     * @returns BusinessAccount OK
     * @throws ApiError
     */
    public static getWhatsAppBusinessAccounts(
        organizationId: string,
    ): CancelablePromise<Array<BusinessAccount>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/organizations/{organizationId}/whatsapp/businessAccounts',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static authorizeWhatsApp(
        requestBody?: WhatsAppOAuthRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/getAccessToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
